import ProfileView from '@/components/Auth/ProfileView'

const ProfileScreen = () => {
  return <ProfileView />
}

export default ProfileScreen
